( function ($) {
Drupal.behaviors.formTypeCheckbox = {
	attach: function(context, settings) {
		//$('.js-form-type-checkbox label', context).once('remove-modals', function () {
		
		
		let checkboxCollection = document.querySelectorAll('.js-form-type-checkbox label');

		checkboxCollection.forEach(el => {
			let 
			label = el,
			checkbox = el.previousElementSibling,
			checked = checkbox.checked,
			checkedClass = checkbox.classList;

			if (label.classList.contains('form-required')) {
				let required = '<span class="js-required">*</span>';
			
				label.insertAdjacentHTML('beforeend', required);
			}

			// console.log('before ' + checked)

			/*
			if (checked) {
				checkbox.setAttribute('checked', true);
			}*/
		
			if (checked === true) {
				checkedClass.add('js-checked');
			}

			el.addEventListener('click', _label => {
				// checked = checked ? false : true;
			
				// console.log(_label.target.previousElementSibling);
			
				// checkbox.checked = !checked;
				// checkbox.setAttribute('checked', !checked);
			
				if (checkedClass.contains('js-checked')) {
					checkedClass.remove('js-checked');
				} else {
					checkedClass.add('js-checked');
				}

			});
		});
		
		//});
	}
};
})(jQuery);